import { useQuery } from '@tanstack/react-query'
import { WhatsNewItem } from 'Modules'

import { AppAdmin } from 'api/app-admin'
import { logError } from 'utils/logger'

import { whatsNewKeys } from './query-keys'

const fetchWhatsNewDetail = async (id: string): Promise<WhatsNewItem | null> => {
  try {
    const res = await AppAdmin.getWhatsNewDetail(id)
    return res.data?.data ?? null
  } catch (error) {
    logError('Error fetching whats new detail:', error)
    return null
  }
}

export const useWhatsNewDetail = (id: string | undefined) => {
  const query = useQuery({
    queryKey: whatsNewKeys.detail(id),
    queryFn: () => fetchWhatsNewDetail(id!),
    enabled: !!id,
    gcTime: 30000,
  })

  return {
    item: query.data,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    refetch: query.refetch,
  }
}
